<template>
    <div class="my_edit">
        <van-cell-group class="my-group">
        
                <van-cell title="头像" center>               
                    <van-uploader :after-read="onRead2">
                        <img :src="userInfo.head_portrait||''" alt="" class="avatar">
                    </van-uploader>
                </van-cell>
                <van-field v-model="form.nickname" label="昵称" size="large" placeholder="请输入用户名" :rules="[{ required: true, message: '请填写昵称' }]"/>
                <van-field v-model="form.realname" label="姓名" size="large" placeholder="请输入用户名" :rules="[{ required: true, message: '请填写用户名' }]"/>

                <div class="van-cell van-cell--large van-field">
                    <div class="van-cell__title van-field__label">
                        <span>性别</span>
                    </div>
                    <div class="van-cell__value van-field__value">
                        <div class="van-field__body">
                            <van-radio-group v-model="form.gender" direction="horizontal">
                                <van-radio :name="1">男</van-radio>
                                <van-radio :name="2">女</van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                </div>


                <van-field v-model="form.birthday" @click="showdate=true" size="large" center readonly label="出生年月" placeholder="请选择出生年月" >
                    <template #button>
                        <van-button size="small"  color="#6A94ED" plain @click="showdate=true"><i class="iconfont icon-rili"></i> 选日期</van-button>
                    </template>
                </van-field>
                <van-field v-model="form.idcard" label="身份证号" size="large" placeholder="请输入身份证号" clearable/>
                <van-field
                        readonly
                        clickable
                        is-link
                        name="picker"
                        :value="form.political"
                        label="政治面貌"
                        placeholder="点击选择政治面貌"
                        @click="showPicker = true"
                />

                <van-field
                        readonly
                        clickable
                        name="picker"
                        is-link
                        :value="form.edu"
                        label="最高学历"
                        placeholder="点击选择最高学历"
                        @click="showPickerEdu = true"
                />


                <van-field v-model="form.address" label="详细地址" size="large" placeholder="请输入详细地址" :rules="[{ required: true, message: '请填写详细地址' }]"/>
                <!--          <van-field v-model="form.mobile" label="联系电话" size="large" placeholder="请输入联系电话" :rules="[{ required: true, message: '请填写联系电话' }]"/>-->

                <!--<van-field v-model="address" label="详细地址" size="large" placeholder="请输入详细地址" />-->
                <van-field v-model="form.mobile" size="large" label="联系电话" placeholder="请输入联系电话" >
                    <template #button>
                        <van-button size="small"  color="#6A94ED" plain @click="sendCode()"><i class="iconfont icon-shouji"></i>验证码</van-button>
                    </template>
                </van-field>
                <!--        <van-cell>-->
                <!--          <template #default>-->
                <!--            <van-button size="small"  color="#6A94ED" plain @click="sendCode()"><i class="iconfont icon-shouji"></i> 获取验证码</van-button>-->
                <!--          </template>-->
                <!--        </van-cell>-->
                <van-field v-model="form.code" label="验证码" size="large" placeholder="请输入验证码" :rules="[{ required: true, message: '请填写验证码' }]"/>
            <!-- <van-calendar v-model="showdate" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" /> -->
            <van-popup v-model="showdate" position="bottom">
                <van-datetime-picker
                        v-model="currentDate"
                        @confirm="onConfirm"
                        type="date"
                        title="选择年月日"
                        :min-date="minDate"
                        :max-date="maxDate"
                />
            </van-popup>
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                        show-toolbar
                        :columns="political"
                        value-key="label"
                        @confirm="onConfirmPolitical"
                        @cancel="showPicker = false"
                />
            </van-popup>
            <van-popup v-model="showPickerEdu" position="bottom">
                <van-picker
                        show-toolbar
                        :columns="edu"
                        value-key="label"
                        @confirm="onConfirmEdu"
                        @cancel="showPickerEdu = false"
                />
            </van-popup>



            <!--<Cell title="地区" is-link @click="area=true" :value="address" :label="street" center>-->
                <!--<template slot="title">-->
                    <!--地区 <Tag type="danger" v-if="userInfo.district_id==''">请补全信息</Tag>-->
                <!--</template>-->
            <!--</Cell>-->
            <!--<Popup title="地区" v-model="area" position="bottom">-->
                <!--<Area :area-list="areaList" @confirm="addressEdit" :value="userInfo.district_id" @cancel="area=false"/>-->
                <!--<Field :error="street===''" v-model="street"  label="街道" placeholder="请输入街道"></Field>-->
            <!--</Popup>-->
        </van-cell-group>
        <div class="footer">
            <van-button class="mvbutton" type="primary" size="large" color="#5D97FF" @click="submit">确认修改</van-button>
        </div>
    </div>
</template>
<script>
    import utils from '../../../libs/utils'
    import AreaList from 'libs/area'
    import './index.less'
    import {Cell, CellGroup,Field,RadioGroup, Radio,Button,Calendar,Uploader,Toast,Picker,Popup,Dialog,DatetimePicker} from 'vant'

    export default {
        computed: {

        },
        data() {
            return {
                area: false,
                userInfo: '',
                areaList: AreaList,
                address: "",
                street:"",
                form:{"realname":"","address":"","gender":1,"idcard":"","mobile":"","birthday":"","idcard_img":"",skuid:'',nickname:''},
                edu:[],
                years:[],
                degrees:[],
                political:[],
                showPicker:false,
                showedu:false,
                showyear:false,
                showdegree:false,
                showdates:false,
                currentDate: new Date(),
                showPickerEdu:false,
                showdate:false,
                minDate: new Date(1960, 0, 1),
                maxDate: new Date(2020, 0, 31),
            }
        },
        components: {
            vanCell:Cell,
            vanCellGroup:CellGroup,
            vanField:Field,
            vanRadioGroup:RadioGroup,
            vanRadio:Radio,
            vanButton:Button,
            vanCalendar:Calendar,
            vanUploader:Uploader,
            vanPicker:Picker,
            vanPopup:Popup,
            Dialog,
            vanDatetimePicker:DatetimePicker,
            Uploader
        },
        methods: {
            onConfirmDate(obj)
            {
                this.forms.date = obj;
                this.showdates = false;
            },
            onConfirmYear(obj)
            {
                this.forms.year = obj;
                this.showyear = false;
            },
            onConfirmDegree(obj)
            {
                console.log(obj)
                this.forms.degree = obj;
                this.showdegree = false;
            },
            onConfirmPolitical(obj)
            {
                this.form.political = obj.label;
                this.showPicker = false;
            },
            onConfirmEdu(obj)
            {
                this.form.edu = obj.label;
                this.showPickerEdu = false;
            },
            onConfirm(date) {
                this.showdate = false;
                this.form.birthday = this.formatDate(date);
            },
            getConfig()
            {
                this.$api.user.config({'config':'political,edu,school_system,degree','type':'select'}).then((res)=>{
                    if(res.code == 200)
                    {
                        this.political = res.data.political
                        this.edu = res.data.edu
                        this.years = utils.getObjectValues(res.data.school_system,'label')
                        this.degrees =utils.getObjectValues(res.data.degree,'label')
                        console.log(this.degrees,'')
                    }
                })

            },
            onRead2(file) {
                let query = new FormData();
                query.append('file',file.file);
                var token = localStorage.getItem('token');
                let config = {
                    headers: { //添加请求头
                        'Content-Type': 'multipart/form-data',
                        'access-token': token,
                    }
                }
                axios.post(host+'/api/v1/file/idcard', query, config).then((res) => {
                    if(res.data.code == 200)
                    {
                        this.form = res.data.data.idcardinfo
                        console.log(this.form,'form')
                    }else{
                        Toast.fail(res.data.message);
                    }
                }).catch((err) => {
                    Toast.fail('系统异常')
                });
            },
            addressEdit(e) {
                if(!this.street) return ;
                this.address = e[0]['name'] + e[1]['name'] + e[2]['name']
                let params = {
                    province_id: e[0]['code'],
                    province: e[0]['name'],
                    city_id: e[1]['code'],
                    city: e[1]['name'],
                    district_id: e[2]['code'],
                    district: e[2]['name'],
                    street:this.street
                };

                this.$api.user.editUserInfo(params).then((res)=>{
                    if(res.code*1===200){
                        this.area = false;
                        let {urid,token} = this.storeuserInfo;
                        let userInfo = res.data;
                        Object.assign(userInfo,{urid,token});
                        this.setUserInfo(userInfo);
                        this.userInfo = userInfo;
                    }
                })
            },
            submit()
            {
                this.$api.user.updateInfo({op:1,forms:JSON.stringify(this.form)}).then((res)=>{
                  if(res.code == 200)
                  {
                     this.$router.push({name:'my'})
                  }
                })
            },
            getUserInfo() {
                this.$api.user.getBaseUserInfo({ismm:2}).then((res)=>{
                    if(res.code == 200)
                    {
                        this.userInfo = res.data
                        this.form.realname = res.data.realname
                        this.form.gender = res.data.gender
                        this.form.birthday = res.data.birthday
                        this.form.idcard = res.data.idcard
                        this.form.political = res.data.political
                        this.form.edu = res.data.edu
                        this.form.address = res.data.address
                        this.form.mobile = res.data.mobile
                        this.form.nickname = res.data.nickname
                        // this.edus = res.data
                        // if(res.data.length==0){
                        //   this.showedu = true
                        // }
                    }
                })
            }
        },
        mounted() {
            this.getConfig()
            this.getUserInfo()
        }
    }
</script>
